import React from 'react';

import { useTrackEventAmplitude } from '../../../core/Tracking/Amplitude/Amplitude';
import { Accordion, useAccordion } from '../../../design-system/components/accordion/Accordion';
import { Typography } from '../../../design-system/components/typography/Typography';
import { HtmlContent } from '../../../domains/Layout/HtmlContent/HtmlContent';
import { QuestionAnswer } from '../../../resources/questionAnswer/domain/types/questionAnswer';

import style from './QuestionsAnswersAccordion.module.css';

type QuestionsAnswersAccordionProps = {
    questionsAnswers: Array<QuestionAnswer>;
    title?: string;
    allExpanded?: boolean;
};

export function QuestionsAnswersAccordion({
    questionsAnswers,
    title,
    allExpanded = false,
}: QuestionsAnswersAccordionProps) {
    const { trackEvent } = useTrackEventAmplitude();

    const items = questionsAnswers.map((questionAnswer) => {
        return {
            value: questionAnswer.id.toString(),
            title: questionAnswer.question,
            content: <HtmlContent htmlContent={questionAnswer.answer} />,
        };
    });

    const defaultValue = allExpanded ? items.map((item) => item.value) : [];

    const accordion = useAccordion(defaultValue);

    return (
        <>
            {title ? (
                <Typography className={style.title} as="h2" scale="primary-l-extra-bold">
                    {title}
                </Typography>
            ) : null}

            <Accordion
                {...accordion}
                HeaderElement="h3"
                items={items}
                onItemChange={({ item, isOpen, index }) => {
                    const questionAnswer = questionsAnswers.find(({ id }) => {
                        return id.toString() === item.value;
                    }) as QuestionAnswer;

                    trackEvent((ampli, defaultProperties) => {
                        ampli.questionClicked({
                            ...defaultProperties,
                            block: 'faq',
                            question_id: questionAnswer.id,
                            question_label: questionAnswer.question,
                            question_number: index + 1,
                            is_open: isOpen,
                        });
                    });
                }}
            />
        </>
    );
}
